import { environment } from '../../environments/environment';
export { environment } from '../../environments/environment';

export function GetContractApiUrl(path: string, params?: Object) {
    const contract = environment.microserviceApiContract;
    let url = environment.apiHost + contract + path;
    if (params instanceof Object) {
        url += '?';

        Object.entries(params).forEach(([param, value]) => {
            url += `${encodeURIComponent(param)}=${encodeURIComponent(value)}&`;
        });
    }
    return url;
}
